import { render, staticRenderFns } from "./FMSendPaymentDialog.vue?vue&type=template&id=2fc08db1&"
import script from "./FMSendPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./FMSendPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports